module.exports = __webpack_public_path__ + "static/groovengo-1987a85b1e3b97a1c3f1a07ba2ffc000.png";